// import { stringifyQuery } from 'vue-router'
import request from '../utils/request'


//获取商店信息
export function getShopMessage(country:string, district:string, prdType:string, province:string){
    return request.get(
        `/query/maintenance`,
        {
            params:{
                country: country,
                district: district,
                prdType: prdType,
                province: province

            }
        }

    )

}

//获取产品列表
export function getProductList(){
    return request.get(`/query/prd`)

}

//获取产品详情
export function getProductDetails(attrKeyIds:string, pNum:number, pSize:number, ppid:string, withPage:boolean){
    return request.get(`/prdDetail`,
    {
        params:{
            attrKeyIds: attrKeyIds,
            pNum: pNum,
            pSize: pSize,
            ppid: ppid,
            withPage:withPage

            

        }
    })

}

//获取预置应用
export function getPresetApp(preCategoryId:string){
    return request.get(`/query/preSetAppDetail`,
    {
        params:{
            preCategory: preCategoryId
        }
    })

}


export function getPresetList(){
    return request.get('/query/preSetAppList')

}

//备件价格查询
export function getReplacementPrice(prdId : string){
   return request.get(`/query/replacement`,
   {
       params:{
           prdId: prdId,
       }
   })
}











